export default "__VITE_ASSET__CDkEXf1A__"